export class AppUser {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.email = json && json.email || null;
        this.databaseID = json && json.database_id || null;
        this.userID = json && json.user_id || null;
        this.profileImage = json && json.profile_image || null;
        this.firstName = json && json.first_name || null;
        this.lastName = json && json.last_name || null;
        this.teamRNID = json && json.team_rn_id || null;
        this.teamName = json && json.team_name || null;
        this.accountConnected = json && json.account_connected || null;
        this.databaseName = json && json.database_name || null;
        this.databaseImageURL = json && json.database_logo_url || null;
        this.bannerImage = json && json.profile_banner || null;
        this.userTypeID = json && json.user_type_id || null;
        this.userTypeName = json && json.user_type_name || null;
        this.appearInSearch = json && json.appear_in_search || false;
        this.verifiedUser = json && json.verified_user || false;
        this.themeID = json && json.theme_id || null;
        this.playerRNID = json && json.player_rnid || null;
        this.isPlayer = json && json.is_player || false;
        this.cellNumber = json && json.cell_number || null;
        this.inactive = json && json.inactive || false;
        this.isScout = json && json.is_scout || null;
        this.connected = json && json.is_connected || false;
        this.isRinknetStaff = json && json.is_rinknet_staff || null;
        this.stripeCustomerID = json && json.stripe_customer_id || null;
        this.revenuecatID = json && json.revenuecat_id || null;
        this.additionalStorage = json && json.additional_storage || null;
        this.isRecruit = json && json.is_recruit || null;
        this.isPendingConnection = json && json.is_pending_connection || null;
        this.conversationSID = json && json.conversation_sid || null;
        this.matchPercent = json && json.match_percent || null;
        this.isRecruitEligiblePlayer = json && json.is_recruit_eligible_player || false;
        this.showPortalScroller = json && json.show_portal_scroller || false;
        this.showRecommended = json && json.show_recommended || false;
        this.userHasPost = json && json.user_has_post || false;
        this.userHasGameLog = json && json.user_has_game_log || false;
        this.positionRNID = json && json.position_rnid || null;
        this.positionName = json && json.position_name || null;
        this.isSkater = json && json.is_skater || false;
        this.highlightVideoLevel = json && json.highlight_video_level || null;

        this.selected = false;
    }

    id: number;
    email: string;
    databaseID: number;
    userID: number;
    profileImage: string;
    firstName: string;
    lastName: string;
    teamRNID: number;
    teamName: string;
    accountConnected: boolean;
    databaseName: string;
    databaseImageURL: string;
    bannerImage: string;
    userTypeID: number;
    userTypeName: string;
    appearInSearch: boolean;
    verifiedUser: boolean;
    themeID: number;
    playerRNID: number;
    isPlayer: boolean;
    cellNumber: string;
    inactive: boolean;
    isScout: boolean;
    isRinknetStaff: boolean;
    stripeCustomerID: string;
    revenuecatID: string;
    additionalStorage: number;
    isRecruit: boolean;
    isPendingConnection: boolean;
    conversationSID: string;
    matchPercent: number;
    isRecruitEligiblePlayer: boolean;
    showPortalScroller: boolean;
    showRecommended: boolean;
    userHasPost: boolean;
    userHasGameLog: boolean;
    positionRNID: number;
    positionName: string;
    isSkater: boolean;
    highlightVideoLevel: number;

    connected: boolean;
    selected: boolean;
}
